/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';

import styles from '../shared/styles/GenUserNavbar.module.css';

import collapseIcon from '../../icons/collapse-nav.svg';
import expandIcon from '../../icons/expand-nav.svg';

type FloatingButtonProps = {
  expandedMenu: boolean;
  setExpandedMenu: (value: React.SetStateAction<boolean>) => void;
};
const GenUserNavBarFloatingButton: React.FC<FloatingButtonProps> = ({ expandedMenu, setExpandedMenu }): JSX.Element => {
  return (
    <>
      {expandedMenu ? (
        <div className={styles['floating-button']}>
          <img src={collapseIcon} alt="Collapse" onClick={() => setExpandedMenu((state) => !state)} />
        </div>
      ) : (
        <div className={`${styles['floating-button']} ${styles['small-button']}`}>
          <img src={expandIcon} alt="Collapse" onClick={() => setExpandedMenu((state) => !state)} />
        </div>
      )}
    </>
  );
};

export default GenUserNavBarFloatingButton;
